export default __webpack_public_path__ + "static/media/marina-portrait.d96f24a1.jpg";